import React, { useEffect, useRef, useState } from "react";
// import { debounce } from "@mui/material";
import { getTransactionSummary } from "../../API  Functions/Eorders";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ShimmerLoader from "../../loading";
import LoadingSpinner from "../Loading";
// import SettlementReportTable from "./TransactionSummaryTable";
import Third from "../Orders/Third";
import FilterSelectBox from "../CustomWidgets/EOrderFilter";
import SelectBox from "../CustomWidgets/SelectBox";
import TransactionSummaryTable from "./TransactionSummaryTable";
import Navbar from "../Navbar/Navbar";
import moment from "moment";
import { ConfigProvider, DatePicker, Space } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ExportCasInOutReportModal from "../../app/SessionHistory/ExportCasInOutReportModal";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import DateFilter from "../ui/DateFilter";
import { checkPermission } from "../../Utils/permissionHelper";

const TransactionSummary = () => {
  const { t, i18n } = useTranslation();

  const [componentData, setComponentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [totalNetAmount, setTotalNetAmount] = useState("");

  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  const store_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  const getTransactionSummaryData = async (
    start_date = startofMonth,
    end_date = formatToday,
    limit = 20,
    offset = 0
  ) => {
    setLoading(true);
    try {
      const response = await getTransactionSummary(
        store_id,
        start_date,
        end_date,
        limit,
        offset
      );

      if (response?.status_code === 200) {
        setTotalNetAmount(response?.total_net_amount)
        setComponentData(response?.data);
      } else {
        setComponentData([]);
        // console.warn("Unexpected status_code:", response?.status_code); // Debug
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
      setComponentData([]);
    } finally {
      setLoading(false);
    }
  };

  const disabledDate = (current) => {
    // Disable dates that are after today
    return current && current > moment().endOf("day");
  };

  const handleExport = async () => {
    let payload = {
      start_date: startDate,
      end_date: endDate,
      company_id: store_id,
    };
    const response = await axiosInstance.post(
      URLS.TRANSACTION_SUMMARY_EXCEL,
      payload
    );
    console.log("handleExport", response);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.data);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      const timestamp = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .replace("T", "_")
        .slice(0, 19);
      const filename = `transaction_summary_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col pb-2 overflow-y-auto  bg-[#F6F7F9]">

        <Navbar heading="Transaction Report" />
        <div className="overflow-y-auto custom-scrollbar">


          {/* === Date Filter Row === */}
          <div className="mt-4 ms-4 me-4">
            <DateFilter
              setSelectedRange={setSelectedRange}
              selectedRange={selectedRange}
              SubmitFilter={(start, date) => {
                setStartDate(start);
                setEndDate(date);
                getTransactionSummaryData(start, date);
              }}
            />
          </div>

          {/* === Row: Total Net Amount & Download Button === */}
          <div className="flex justify-between items-center mt-4 ms-2 md:ms-4 me-2 md:me-4 gap-2 md:gap-4">
            {/* Total Net Amount Box */}
            <div className="flex flex-col justify-center h-16 w-48 bg-[#FFEDB1] text-gray-800 rounded-lg px-4 py-2">
              <span className="text-sm font-medium">{t("Total Net Amount")}</span>
              <span className="text-base font-bold leading-tight">
                EGP {totalNetAmount}
              </span>
            </div>

            {/* Download Button */}
            <button
              className={`h-11 w-48 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2
        ${componentData.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
              // onClick={() => handleExport()}
              onClick={() => {
                if (checkPermission("/paymentsettlement/transactionsummary", isGinne)) {
                  handleExport();
                }
              }}
              disabled={componentData.length === 0}
            >
              <DownloadOutlined style={{ fontSize: "1.5em" }} />
              <span>{t("Download in Excel")}</span>
            </button>
          </div>

          {/* === Table === */}
          <div>
            <TransactionSummaryTable
              tabledata={componentData}
              user_id={user_id}
              store_id={store_id}
              pagination={(values) =>
                getTransactionSummaryData(
                  startDate,
                  endDate,
                  values.limit,
                  values.offset
                )
              }
            />
          </div>
        </div>
      </div>
    </>

  );
};

export default TransactionSummary;
